import { EmployeeAssignmentDetailModel } from 'api/models';
import { getInspectionType } from 'pages/PostInspectionFlow/utils';
import { formatString } from 'strings';
import { POST_INSPECTION_FLOW_STRINGS } from 'strings/post-inspection-flow';
import PostInspectionContentLayout from '../../../PostInspectionContentLayout/PostInspectionContentLayout';
import { getImprovementsAssignedEmployee } from '../utils';
import BelongStandards from './components/BelongStandards';
import DepositDeductions from './components/DepositDeductions';
import OurPromise from './components/OurPromise';
import WearAndTear from './components/WearAndTear';
import WearAndTearVsResidentDamage from './components/WearAndTearVsResidentDamage';

export const ResponsibilityPreMoveOutContent = () => {
  return (
    <>
      <OurPromise />

      <BelongStandards />

      <WearAndTear />
    </>
  );
};

const ResponsibilityMoveOutContent = () => {
  return (
    <>
      <WearAndTearVsResidentDamage />

      <WearAndTear />

      <DepositDeductions />
    </>
  );
};

type Props = {
  stepResource: {
    // `leases` and `inspection` are read below but were missing here. This is a
    // step payload rather than the generated `UnitListingDetailsModel`, which
    // carries none of these three fields, so the shape stays local and is
    // declared only as deep as the reads go.
    homeListingDetailsModel: {
      employeeAssignments: EmployeeAssignmentDetailModel[];
      inspection?: { leaseUniqueId?: string };
      leases?: {
        basicInfo?: { areResidentsAdopted?: boolean; leaseId?: string };
      }[];
    };
  };
  onSaveAndNext: () => void;
  stepConfigs: { [key: string]: unknown };
  stepConfig: { [key: string]: unknown };
  flow: string;
  stepData: {
    isDepositFreeLease: boolean;
  };
};

const Responsiblity = ({
  stepResource,
  onSaveAndNext,
  stepConfigs,
  stepConfig,
  flow,
  stepData,
}: Props) => {
  const currentLease = stepResource.homeListingDetailsModel?.leases?.find(
    (lease) =>
      lease?.basicInfo?.leaseId ===
      stepResource?.homeListingDetailsModel?.inspection?.leaseUniqueId,
  );

  const isAdoptedHome = currentLease?.basicInfo?.areResidentsAdopted;

  // Asserted: the reads below are unconditional, so a flow with no sub-type
  // already threw here. `getInspectionType` now says it can return `undefined`;
  // this states the assumption the page always made.
  const inspectionType = getInspectionType(flow)!;

  const assessedBy = getImprovementsAssignedEmployee({
    employeeAssignments:
      stepResource?.homeListingDetailsModel?.employeeAssignments,
    isMoveOut: inspectionType.isMoveOut,
  });

  const stepTitle = () => {
    if (isAdoptedHome) {
      return formatString(
        POST_INSPECTION_FLOW_STRINGS['responsibility.title.adopted_home'],
      );
    }

    if (inspectionType.isPreMoveOut) {
      return formatString(
        POST_INSPECTION_FLOW_STRINGS['responsibility.title.pre_move_out'],
      );
    }

    if (stepData?.isDepositFreeLease) {
      return formatString(
        POST_INSPECTION_FLOW_STRINGS[
          'responsibility.title.move_out.deposit_free'
        ],
      );
    }

    return formatString(
      POST_INSPECTION_FLOW_STRINGS['responsibility.title.move_out'],
    );
  };

  return (
    <PostInspectionContentLayout
      stepConfigs={stepConfigs}
      stepConfig={stepConfig}
      title={stepTitle()}
      employee={assessedBy}
      showCityBackground={false}
    >
      <div className="mb-3xl hidden justify-center md:flex">
        <PostInspectionContentLayout.CtaButton
          onClick={() => onSaveAndNext()}
          extraSpace={800}
        >
          {formatString(POST_INSPECTION_FLOW_STRINGS['responsibility.next'])}
        </PostInspectionContentLayout.CtaButton>
      </div>

      <div className="h-0 w-0 overflow-hidden md:hidden">
        <PostInspectionContentLayout.CtaButton
          onClick={() => onSaveAndNext()}
          displayfixed
        >
          {formatString(POST_INSPECTION_FLOW_STRINGS['responsibility.next'])}
        </PostInspectionContentLayout.CtaButton>
      </div>
      {inspectionType.isPreMoveOut ? (
        <ResponsibilityPreMoveOutContent />
      ) : (
        <ResponsibilityMoveOutContent />
      )}
    </PostInspectionContentLayout>
  );
};

export default Responsiblity;
